// import Card from 'components/card';
// import Nodatafound from 'pages/Common/Nodatafound';
// import { useEffect, useState } from 'react';
// import { BallTriangle } from 'react-loader-spinner';

// const StudentData = ({
//   classData,
//   attendance,
//   confirmPlacementReady,
//   getStudents,
//   setAttendance,
// }) => {
//   const [loading, setLoading] = useState(true);
//   const [searchQuery, setSearchQuery] = useState('');

//   useEffect(() => {
//     if (classData) {
//       setLoading(true);
//       getStudents().finally(() => setLoading(false));
//     }
//   }, [classData]);

//   const handlePriorityChange = (studentId, value) => {
//     setAttendance((prevAttendance) => {
//       return prevAttendance.map((student) => {
//         if (student.id === studentId) {
//           return { ...student, placementPriority: value };
//         }
//         return student;
//       });
//     });
//   };

//   // Filter students based on search query
//   const filteredStudents = attendance.filter((student) =>
//     student.name.toLowerCase().includes(searchQuery.toLowerCase())
//   );

//   return (
//     <Card extra={'w-full sm:overflow-auto p-4 '}>
//       <div className="mt-4 flex flex-col items-center justify-center space-y-2 text-sm text-gray-600 dark:text-white sm:flex-row sm:space-x-2 sm:space-y-0">
//         <div className="flex items-center space-x-2">
//           <b>Note:</b>
//         </div>
//         <div className="flex items-center space-x-2">
//           <p>Click "Mark Ready" to mark a student as ready for placement.</p>
//         </div>
//       </div>

//       {/* Search Input */}
//       <div className="mt-6 flex justify-start">
//         <div className="relative w-full max-w-md">
//           <input
//             type="text"
//             placeholder="Search by student name..."
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//             className="w-full rounded-md border border-gray-300 px-4 py-2 text-sm focus:border-brand-500 focus:outline-none dark:border-navy-600 dark:bg-navy-700 dark:text-white dark:focus:border-brand-400"
//           />
//           {searchQuery && (
//             <button
//               onClick={() => setSearchQuery('')}
//               className="absolute right-3 top-2 text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300"
//             >
//               ✕
//             </button>
//           )}
//         </div>
//       </div>

//       <div>
//         {loading ? (
//           <div className="flex h-64 items-center justify-center">
//             <div className="flex h-40 items-center justify-center">
//               <BallTriangle color="#5431ed" />
//             </div>
//           </div>
//         ) : attendance.length ? (
//           <div className="mt-8 overflow-x-scroll xl:overflow-x-hidden">
//             <table className="w-full">
//               <thead className="w-full">
//                 <tr className="items-center border-b border-gray-200 dark:border-white/10">
//                   <th className="px-[27px] pb-[12px] pt-[32px] text-center text-xs tracking-wide text-gray-600">
//                     <div className="text-xs font-bold">SR.NO</div>
//                   </th>
//                   <th className="px-[27px] pb-[12px] pt-[32px] text-center text-xs tracking-wide text-gray-600">
//                     <div className="text-xs font-bold">NAME</div>
//                   </th>
//                   <th className="px-[27px] pb-[12px] pt-[32px] text-center text-xs tracking-wide text-gray-600">
//                     <div className="text-xs font-bold">PRIORITY</div>
//                   </th>
//                   <th className="px-[27px] pb-[12px] pt-[32px] text-center text-xs tracking-wide text-gray-600">
//                     <div className="text-xs font-bold">STATUS</div>
//                   </th>
//                   <th className="px-[27px] pb-[12px] pt-[32px] text-center text-xs tracking-wide text-gray-600">
//                     <div className="text-xs font-bold">ACTION</div>
//                   </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {filteredStudents.length > 0 ? (
//                   filteredStudents.map((student, index) => (
//                     <tr
//                       key={student.id}
//                       className={`items-center border-b border-gray-200 ${
//                         student.ready ? 'bg-green-50 dark:bg-green-900/10' : ''
//                       } dark:border-white/10`}
//                     >
//                       <td className="mt-[20px] px-[27px] py-[16px]">
//                         <div className="w-full text-center font-medium text-navy-700 dark:text-white">
//                           {index + 1}
//                         </div>
//                       </td>
//                       <td className="mt-[20px] px-[27px] py-[16px]">
//                         <div className="w-full text-center font-medium text-navy-700 dark:text-white">
//                           {student.name}
//                         </div>
//                       </td>
//                       <td className="mt-[20px] px-[27px] py-[16px]">
//                         <div className="w-full text-center font-medium text-navy-700 dark:text-white">
//                           <select
//                             value={student.placementPriority}
//                             onChange={(e) =>
//                               handlePriorityChange(student.id, e.target.value)
//                             }
//                             className="dark:bg-navy-800"
//                             disabled={student.ready}
//                           >
//                             <option value="High">High</option>
//                             <option value="Medium">Medium</option>
//                             <option value="Low">Low</option>
//                           </select>
//                         </div>
//                       </td>
//                       <td className="mt-[20px] px-[27px] py-[16px]">
//                         <div className="w-full text-center font-medium text-navy-700 dark:text-white">
//                           {student.ready ? (
//                             <span className="rounded-md bg-green-100 px-2 py-1 text-xs font-semibold text-green-800 dark:bg-green-900/30 dark:text-green-400">
//                               Ready for placement
//                             </span>
//                           ) : (
//                             <span className="rounded-md bg-yellow-100 px-2 py-1 text-xs font-semibold text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400">
//                               Not ready
//                             </span>
//                           )}
//                         </div>
//                       </td>
//                       <td className="mt-[20px] px-[27px] py-[16px]">
//                         <div className="flex w-full justify-center">
//                           <button
//                             onClick={() => confirmPlacementReady(student)}
//                             disabled={student.ready}
//                             className={`rounded-md px-3 py-1 text-xs font-semibold ${
//                               student.ready
//                                 ? 'cursor-not-allowed bg-gray-200 text-gray-500 dark:bg-gray-700 dark:text-gray-400'
//                                 : 'cursor-pointer bg-brand-500 text-white hover:bg-brand-600 dark:bg-brand-400 dark:hover:bg-brand-300'
//                             }`}
//                           >
//                             {student.ready ? 'Already Ready' : 'Mark Ready'}
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan={5} className="py-8 text-center">
//                       <div className="flex flex-col items-center justify-center">
//                         <p className="text-gray-600 dark:text-gray-400">
//                           No students found matching "{searchQuery}"
//                         </p>
//                         <button
//                           onClick={() => setSearchQuery('')}
//                           className="mt-2 text-brand-500 hover:text-brand-600 dark:text-brand-400 dark:hover:text-brand-300"
//                         >
//                           Clear search
//                         </button>
//                       </div>
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         ) : (
//           <div className="flex items-center justify-center dark:text-gray-600">
//             <p className="mt-5 text-center ">
//               <Nodatafound title="No student data found." />
//             </p>
//           </div>
//         )}
//       </div>
//     </Card>
//   );
// };

// export default StudentData;
import Card from 'components/card';
import Nodatafound from 'pages/Common/Nodatafound';
import { useEffect, useState } from 'react';
import { BallTriangle } from 'react-loader-spinner';

const StudentData = ({
  attendance,
  confirmPlacementReady,
  setAttendance,
  loadingFromParent = false, // optional
}) => {
  const [searchQuery, setSearchQuery] = useState('');

  /* ================= PRIORITY CHANGE ================= */
  const handlePriorityChange = (studentId, value) => {
    setAttendance((prev) =>
      prev.map((student) =>
        (student.id || student._id) === studentId
          ? { ...student, placementPriority: value }
          : student
      )
    );
  };

  /* ================= FILTER ================= */
  const filteredStudents = attendance.filter((student) =>
    student.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <Card extra="w-full sm:overflow-auto p-4">
      {/* NOTE */}
      <div className="mt-4 flex justify-center text-sm text-gray-600 dark:text-white">
        <b>Note:</b>&nbsp;Click "Mark Ready" to mark a student as ready for
        placement.
      </div>

      {/* SEARCH */}
      <div className="mt-6 flex justify-start">
        <div className="relative w-full max-w-md">
          <input
            type="text"
            placeholder="Search by student name..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full rounded-md border px-4 py-2 text-sm dark:bg-navy-700 dark:text-white"
          />
          {searchQuery && (
            <button
              onClick={() => setSearchQuery('')}
              className="absolute right-3 top-2 text-gray-400"
            >
              ✕
            </button>
          )}
        </div>
      </div>

      {/* TABLE / STATES */}
      {loadingFromParent ? (
        <div className="flex h-64 items-center justify-center">
          <BallTriangle color="#5431ed" />
        </div>
      ) : attendance.length === 0 ? (
        <div className="mt-6 flex justify-center">
          <Nodatafound title="No student data found." />
        </div>
      ) : (
        <div className="mt-8 overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b">
                {['SR.NO', 'NAME', 'PRIORITY', 'STATUS', 'ACTION'].map((h) => (
                  <th
                    key={h}
                    className="px-6 py-4 text-center text-xs font-bold"
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {filteredStudents.length > 0 ? (
                filteredStudents.map((student, index) => {
                  const studentId = student.id || student._id;

                  return (
                    <tr
                      key={studentId}
                      className={`border-b ${
                        student.ready ? 'bg-green-50 dark:bg-green-900/10' : ''
                      }`}
                    >
                      <td className="py-4 text-center">{index + 1}</td>
                      <td className="py-4 text-center">{student.name}</td>

                      <td className="py-4 text-center">
                        <select
                          value={student.placementPriority}
                          onChange={(e) =>
                            handlePriorityChange(studentId, e.target.value)
                          }
                          disabled={student.ready}
                          className="dark:bg-navy-800"
                        >
                          <option value="High">High</option>
                          <option value="Medium">Medium</option>
                          <option value="Low">Low</option>
                        </select>
                      </td>

                      <td className="py-4 text-center">
                        {student.ready ? (
                          <span className="rounded bg-green-100 px-2 py-1 text-xs text-green-700">
                            Ready
                          </span>
                        ) : (
                          <span className="rounded bg-yellow-100 px-2 py-1 text-xs text-yellow-700">
                            Not Ready
                          </span>
                        )}
                      </td>

                      <td className="py-4 text-center">
                        <button
                          onClick={() => confirmPlacementReady(student)}
                          disabled={student.ready}
                          className={`rounded px-3 py-1 text-xs ${
                            student.ready
                              ? 'cursor-not-allowed bg-gray-300'
                              : 'bg-brand-500 text-white hover:bg-brand-600'
                          }`}
                        >
                          {student.ready ? 'Already Ready' : 'Mark Ready'}
                        </button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={5} className="py-8 text-center text-gray-500">
                    No students found for "{searchQuery}"
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
};

export default StudentData;
